import "core-js/modules/es.json.stringify.js";
import { onMounted, ref } from "vue";
import { useNewsStore } from "../../../store/news"; //引入news仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { useRouter } from "vue-router";
export default {
  name: "NewsList",
  setup: function setup() {
    var store = useNewsStore();
    var router = useRouter();
    onMounted(function () {
      sendTrends(); //发送请求获取 行业动态 数据
      // sendNewLists()  ////通知vuex发送请求H获取新闻列表的数据
    }); //数据

    var _storeToRefs = storeToRefs(store),
        newsList = _storeToRefs.newsList; //从仓库获取新闻列表的数据


    var isShowNav = ref(true); //导航选中样式

    var isShowNews = ref(false); //切换公司新闻选项卡动画

    var isShowTrends = ref(false); //切换行业动态选项卡动画
    //方法
    //通过编程式导航的方式将参数传递到新闻详情页

    function goNewsDetail(n) {
      router.push({
        path: "/news/newsdetails",
        query: {
          imgUrl: n.imgUrl,
          title: n.title,
          content: JSON.stringify(n.content),
          releaseDate: n.releaseDate
        }
      }); //将该函数包裹一个定时器确保可以获取跳转页面后的指定位置的id

      setTimeout(function () {
        var goDetailTop = document.getElementById('long-left');
        goDetailTop.scrollIntoView({
          behavior: 'smooth',
          //平滑滚动
          block: "center" //将指定位置滚动到页面中间

        });
      }, 100);
    }

    function changeNav(id) {
      if (id == 'trends') {
        //点击 行业动态
        isShowNav.value = false; //将 行业动态 选项卡设为选中的样式

        sendTrends(); //发送请求获取 行业动态 数据

        isShowTrends.value = true; //加载 行业动态 列表动画

        if (isShowNews.value) {
          isShowNews.value = false; //点击 行业动态 选项卡的时候卸载行业动态列表动画
        }
      } else if (id == 'news') {
        //点击 公司新闻
        isShowNav.value = true; //将 公司新闻 选项卡设为选中的样式

        sendNewLists(); //发送请求获取新闻列表数据

        isShowNews.value = true; //加载 公司新闻 列表动画

        isShowTrends.value = false; //点击 公司新闻 选项卡的时候卸载 行业动态 列表动画
      }
    } //通知vuex发送请求获取新闻列表的数据


    function sendNewLists() {
      store.getNewsList();
    } //通知vuex发送请求获行业动态的数据


    function sendTrends() {
      store.getTrends();
    }

    return {
      newsList: newsList,
      isShowNav: isShowNav,
      isShowNews: isShowNews,
      isShowTrends: isShowTrends,
      goNewsDetail: goNewsDetail,
      changeNav: changeNav
    };
  }
};